import { downloadCSVFile, getPathAPI } from "@/helpers";
import { AxiosRequestConfig } from "axios";
import BaseCollectionService from "./base.collection.service";
import { ResponseWrapper } from "./response_wrapper";

export type IUnderWritingQuestionsExportPayload = {
  fields: string[];
  query?: Record<string, any>;
};

class UnderWritingQuestionsExportService extends BaseCollectionService {
  constructor() {
    super("underwriting-questions");
  }
  public async exportUnderWritingQuestions(
    payload: IUnderWritingQuestionsExportPayload
  ): Promise<ResponseWrapper> {
    const axiosConfig: AxiosRequestConfig = {
      baseURL: getPathAPI(),
      url: "underwriting-questions/export",
      method: "GET",
      responseType: "blob",
      params: {
        fields: payload.fields,
        ...payload.query
      }
    };

    let response;
    try {
      response = await this.request(axiosConfig, { useToken: "access" });
    } catch (error) {
      const blob = error?.raw?.response?.data;
      if (blob instanceof Blob) {
        const text = await blob.text();
        try {
          const json = JSON.parse(text);
          throw new Error(
            json.response?.message ||
              json.message ||
              json.error ||
              "Failed to export underwriting questions"
          );
        } catch (parseError) {
          if (parseError instanceof SyntaxError) {
            throw new Error(
              error.message || "Failed to export underwriting questions"
            );
          }
          throw parseError;
        }
      }
      throw error;
    }

    downloadCSVFile(response.data, "UnderWritingQuestions.csv");

    return response;
  }
}

export default new UnderWritingQuestionsExportService();
